module.exports = __webpack_public_path__ + "static/media/Michael.564d0425.png";